export class PlayingCardDTO {
    order: number;
    value: string;

    constructor(order: number, value: string) {
        this.order = order;
        this.value = value;
    }
}